import { ReactComponent as IconChevron } from '@/assets/svgs/profile-chevron.svg'
import { useRef, useEffect } from 'react'
import Popover from '@/components/Popover'
import iconBuilding from '@/assets/svgs/icon-building.svg'

const Profile = ({ label, image , options, isActive, setIsActive, handleSelected}) => {

	const profile = useRef();

	useEffect(()=>{
		const checkIfClickedOutside = (e)=>{
			if(isActive && profile.current && !profile.current.contains(e.target)){
				setIsActive(false)
			}
		}
		document.addEventListener("click",checkIfClickedOutside)
		return () =>{
			document.removeEventListener("click",checkIfClickedOutside)
		}
	},[isActive])

	return (
		<div className="profile" ref={profile}>
			<div className="profile-header" onClick={()=>setIsActive(!isActive)}>
				<div className="profile-header__left">
					<div className="avatar" style={{ backgroundImage: image ? `url(${image})` : `url(${iconBuilding})` }}></div>
				</div>
				<div className="profile-header__right">
					<div className="profile-header__action">
						<div className="profile-header__name">{label}</div>
						<div className="profile-header__more" data-testid="dropdown-option"><IconChevron /></div>
						<Popover visible={isActive} placement="bottom-end">
							<Popover.Content>
								<div className="profile-dropdown__content">
									{options?.map((option)=>(
										<div className="profile-dropdown__item" id={option === 'Logout' ? 'logout-id' : 'account-settings-id'} key={option} onClick={()=>{handleSelected(option)}}>
										{option}
									</div>
									))}
								</div>
							</Popover.Content>
						</Popover>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Profile
